export default "__VITE_ASSET__ylypgNmr__"